import React from "react";
import { RawStaticInput } from "./StaticInput";
export const StaticFormGroup = ({ label, value }) => {
    return (React.createElement("div", { className: "form-group" },
        React.createElement(RawStaticInput, { value: value, label: label })));
};
